import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import {CellClickedEvent, GridOptions} from 'ag-grid';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { UsersService } from 'app/pages/users/users.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { constant } from '../../../app.constants';
import { T2CardComponent } from '../../../trip2-theme/components/t2-card/t2-card.component';
import { BooleanCheckComponent } from '../../A2-utils/grid-components/boolean-check/boolean-check.component';
import { ProvidersBillingService } from '../providers-billing-service.service';
import {assignNewObjet, generateAlertColumn, iconAlert, viewMessageAlertRider} from '../../A2-utils/export-functions/functions-services';
import {ITripDetail} from '../../../core/interfaces/trip-detail.interface';
import {EnumTypeAlertRider, RiderAlertService} from '../../rider/services/rider-alert.service';
import {Subscription} from 'rxjs/Subscription';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-unprocessed-claims',
  templateUrl: './unprocessed-claims.component.html',
  styleUrls: ['./unprocessed-claims.component.scss']
})
export class UnprocessedClaimsComponent extends ParentModule implements OnInit {

  protected grid = <GridOptions> {};
  protected showIncompletes = true;
  protected providers = [];
  protected selectedProvider: any;
  isOpenedRider = false;
  visibleReservation = false;
  selectedTripData: any;
  enableClearSort = true;

  incompleteTrips = undefined;
  tripsReadyToBill = undefined;
  onFiltered: boolean;
  viewProgressBar: boolean;
  progress: number;
  tripids = [];
  @ViewChild('driverManifest') private driverManifest: T2CardComponent;
  public getRowNodeId;
  private observables: Subscription[] = [];
  constructor(
    private loading: T2LoadingService,
    private service: ProvidersBillingService,
    private userService: UsersService,
    private _riderAlertService: RiderAlertService,
    private injec: Injector,
    private toastrAlertHelper: ToastrAlertHelper,
  ) {
    super('app-unprocessed-claims', injec);
    this.grid.columnDefs = this.getColumns();
    this.grid.onFilterChanged = (params) => {
      this.onFiltered = params.api['filterManager'].advancedFilterPresent;
    };
    this.grid.onSortChanged = () => {
      this.enableClearSort = false;
    };

    // TODO Cargar Grid Vacia
    this.grid.onGridReady = () => {
      this.grid.api.setRowData([]);
    };

    this.getRowNodeId = function (data) {
      return data.tripid;
    };
  }

  ngOnInit() {
    this.getProviders();
    this.observables.push(
      this.service.ReloadGridUnprocess$.subscribe((event) => {
        if (event) {
          this.onChangeProvider();
        }
      })
    );
  }

  getIncompleteTrips() {
    if (this.selectedProvider) {
      this.loading.show('Loading...');
      this.observables.push(
        this.service.getIncompleteTrips(this.selectedProvider).subscribe(
          response => {
            if (this.grid) {
              if (this.grid.api && this.showIncompletes) {
                const filter = this.grid.api.getFilterModel();
                this.grid.api.setRowData(response);
                this.enableClearSort = true;
                this.grid.api.setFilterModel(filter);
              }
            }
            this.loading.hiden();
            this.incompleteTrips = response;
          },
          error => {
            this.loading.hiden();
            this.toastrAlertHelper.error(error.message);
          }
        )
      );
    }
  }

  getTripsReadyToBill() {
    if (this.selectedProvider) {
      this.loading.show('Loading...');
      this.observables.push(
        this.service.getTripsReadyToBill(this.selectedProvider).subscribe(
          response => {
            this.loading.hiden();
            if (this.grid) {
              if (this.grid.api && !this.showIncompletes) {
                const filter = this.grid.api.getFilterModel();
                this.grid.api.setRowData(response);
                this.enableClearSort = true;
                this.grid.api.setFilterModel(filter);
              }
            }
            this.tripsReadyToBill = response;
          },
          error => {
            this.loading.hiden();
            this.toastrAlertHelper.error(error.message);
          }
        )
      );
    }
  }

  openReservation(event) {
    this.selectedTripData = event.data;
  }

  /**
   * this execute when change tabs
   * @param show show incompletes
   */
  onChangeTabs(show) {
    this.showIncompletes = show;
    // this.grid.columnApi.setColumnVisible('check', !this.showIncompletes);
    this.grid.columnApi.setColumnVisible('errorValid', !this.showIncompletes);
    if (show) {
      this.grid.api.setRowData(this.incompleteTrips);
    } else {
      this.grid.api.setRowData(this.tripsReadyToBill);
    }
    this.enableClearSort = true;
  }

  onChangeProvider() {
    this.tripsReadyToBill = this.incompleteTrips = undefined;
    this.getIncompleteTrips();
    this.getTripsReadyToBill();
  }

  clickInCell(event: any) {

    if (event.colDef.colId === 'errorValid' && event.data.messagesErrorValid) {

      let messages = '';

      event.data.messagesErrorValid.forEach(element => {
        messages += `
          <p>
            <strong>${element.field}</strong> :
            ${element.description}
          </p>
        `;
      });

      if (messages) {
        Swal({
          title: `<strong>Reservation: ${event.data.consecutive}</strong>`,
          html: `
            <div class="color-danger">
              Errors #: <strong>${event.data.messagesErrorValid.length}</strong>
            <div>
            <div class="margin-t-10"><strong>Details of Fails</strong><div>
            <div class="container margin-t-10 height-200 scrollbar scrollbar-small padding-b-100">
              ${messages}
            </div>
          `,
          type: 'error',
          showCancelButton: false,
          confirmButtonText: 'Accept',
          cancelButtonText: 'Cancel'
        });
      }
    }

    if (event.colDef.colId === 'tripmanifest') {
      this.openReservation(event);
      this.addManifests();
      // this.driverManifest.open();
    }
    this.showAlert(event);

  }

  sendErrorToGrid(trips) {
    const data = [];
    this.tripsReadyToBill.forEach(element => {
      trips.forEach(elem => {
        if (element.tripid === elem.tripid) {
          element.errorValid = elem.success;
          element.messagesErrorValid = elem.filedarray;
        }
      });

      data.push(element);
    });

    this.tripsReadyToBill = data;
    this.grid.api.setRowData(this.tripsReadyToBill);
    this.enableClearSort = true;
    // this.onChangeTabs(false);
  }

  validateTrips() {
    const trips = [];
    this.grid.api.forEachNodeAfterFilter((node) => {
      if (node.isSelected()) {
        trips.push(node.data.tripid);
      }
    });

    if (trips.length > 0) {
      this.progress = 0;
      this.viewProgressBar = true;

      const data = {
        tripstochange: trips,
        providerid: this.selectedProvider
      };

      this.observables.push(
        this.service
        .validTripsBeforeSubmit(data)
        .finally(() => {
          this.progress = 100;
          setTimeout(() => {
            this.viewProgressBar = false;
          }, 1500);
        })
        .subscribe((success) => {
          const tripsErrors = [];
          const tripsSuccessful = [];
          success.forEach(element => {
            if (element.success) {
              tripsSuccessful.push(element);
            } else {
              tripsErrors.push(element);
            }
          });
          if (tripsErrors.length) {
            this.sendErrorToGrid(success);
            this.buildViewErrors(tripsSuccessful, tripsErrors);
          } else {
            this.showSwalDialog(constant.MESSAGE_TRIP_SUBMIT, () => {
              this.submitTrips();
            });
          }
        }, (error) => {
        })
      );
    } else {
      this.toastrAlertHelper.warning('Please select a row');
    }
  }

  /**
   * submit trips
   */
  submitTrips() {
    const trips = [];
    this.grid.api.forEachNodeAfterFilter((node) => {
      if (node.isSelected()) {
        trips.push(node.data.tripid);
      }
    });

    if (trips.length > 0) {
      this.progress = 0;
      this.viewProgressBar = true;
      const data = {
        tripstochange: trips,
        providerid: this.selectedProvider
      };
      this.observables.push(
        this.service.submitTrips(data)
        .finally(() => {
          this.progress = 100;
          setTimeout(() => {
            this.viewProgressBar = false;
          }, 1500);

        }).subscribe((success) => {

          const tripsErrors = [];
          let tripsSuccessful = [];

          if (success.success) {
            tripsSuccessful = data.tripstochange;
          } else {
            success.data.forEach(element => {
              if (element.success) {
                tripsSuccessful.push(element);
              } else {
                tripsErrors.push(element);
              }
            });
          }

          this.buildViewErrors(tripsSuccessful, tripsErrors, true);
        })
      );
    } else {
      this.toastrAlertHelper.warning('Please select a row');
    }
  }

  buildViewErrors(tripsSuccessful: any, tripsErrors: any, callBack?: boolean) {
    let messages = '';
    tripsErrors.forEach(element => {
      messages +=
      `<div>
        <p><strong>
          Trip: ${element.consecutive}
        </p></strong>`;
      element.filedarray.forEach(elem => {
        messages += `
          <p>
            <strong>${elem.field}</strong> :
            ${elem.description}
          </p>
        `;
      });
      messages += `</div>`;
    });

    Swal({
      title: '<strong>Trips Errors</strong>',
      html: `
        <div class="color-success">Successful Trips: <strong>${tripsSuccessful.length}</strong><div>
        <div class="color-danger">
          Error Trips: <strong>${tripsErrors.length}</strong>
        <div>
        <div class="margin-t-10"><strong>Details of Fails</strong><div>
        <div class="container margin-t-10 height-200 scrollbar scrollbar-small padding-b-100">
          ${messages}
        </div>
      `,
      type: 'info',
      showCancelButton: false,
      confirmButtonText: 'Accept',
      cancelButtonText: 'Cancel'
    }).then((result: any) => {
      if (callBack) {
        this.onChangeProvider();
      }
    });
  }

  /**
   * @name clearFilters
   * @description clear grid filters
   */
  clearFilters() {
    this.grid.api.setFilterModel(null);
    this.onFiltered = false;
  }

  /**
   * @name clearSortExport
   * @description clear grid sort
   */
  clearSort() {
    this.grid.api.setSortModel(null);
    this.enableClearSort = true;
  }

  private getProviders() {
    this.observables.push(
      this.userService.getProvidersForUserOrderBy().subscribe(
        data => {
          this.providers = data;
          if (data.length === 1) {
            this.selectedProvider = data[0].companyid;
          }
        }
      )
    );
  }
  private getColumns() {
    return [
      {
        colId: 'check',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 40
      },
      generateAlertColumn(),
      {
        headerName: 'DOS',
        field: 'dateofserviceformatted',
        colId: 'dateofserviceformatted',
        width: 150
      },
      {
        headerName: 'Validation',
        field: 'errorValid',
        colId: 'errorValid',
        width: 80,
        hide: this.showIncompletes,
        cellRenderer: (params) => {
          let ico = '';
          if (params.data.errorValid === true) {
            ico = 'fa-check color-success';
          }
          if (params.data.errorValid === false) {
            ico = 'fa-exclamation color-danger';
          }
          return `<i class="fa ${ico}" aria-hidden="true"></i>`;
        }
      },
      {
        headerName: 'Manifest',
        field: 'tripmanifest',
        colId: 'tripmanifest',
        width: 100,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'Reservation',
        field: 'consecutive',
        colId: 'reservation',
        width: 100
      },
      {
        headerName: 'Trip Status',
        field: 'tripstatus',
        colId: 'tripstatus',
        width: 100
      },
      {
        headerName: 'Payment Status',
        field: 'paymentstatus',
        colId: 'PaymentStatus',
        width: 100
      },
      {
        headerName: 'Patient Name',
        field: 'ridername',
        colId: 'patientname'
      },
      {
        headerName: 'Apt Time',
        field: 'appointmenttime',
        colId: 'appointmenttime'
      },
      {
        headerName: 'Sch. PU Time',
        field: 'pickup',
        colId: 'putime',
        width: 100
      },
      {
        headerName: 'Act. PU Time',
        field: 'actualpickupformatted',
        colId: 'actualpickup',
        width: 100
      },
      {
        headerName: 'Pickup',
        field: 'pickupaddress',
        colId: 'pickup',
        width: 300
      },
      {
        headerName: 'Act. DO Time',
        field: 'actualdropoffformatted',
        colId: 'dropofftime',
        width: 100
      },
      {
        headerName: 'Destination',
        field: 'dropoffaddress',
        colId: 'destination',
        width: 300
      },
      {
        headerName: 'Leg',
        field: 'leg',
        colId: 'leg',
        width: 100
      },
      {
        headerName: 'Driver Name',
        field: 'drivername',
        colId: 'drivername',
        width: 200
      },
      {
        headerName: 'Veh. Number',
        field: 'vehiclecode',
        colId: 'vehiclenumber',
        width: 100
      },
      {
        headerName: 'Signature',
        field: 'tripreasonsign',
        colId: 'signature'
      },
      {
        headerName: 'Amnt Paid Prov.',
        field: 'provideramount',
        colId: 'amount',
        width: 100,
        cellRenderer: (params) => {
          return params.value ? '$' + params.value : '';
        }
      }
    ];
  }

  onGridReady(event) {
    event.api.sizeColumnsToFit();
  }

  onFinishRecalculate(event) {
    if (event) {
      this.grid.api.deselectAll();
    } else {
      this.toastrAlertHelper.info('Reloading data...');
      this.onChangeProvider();
    }
  }

  showSwalDialog(text, callback?) {
    Swal({
      title: 'Terms and conditions',
      html: '<div style="text-align: justify"> <input id="confirm" type=checkbox></input>' + text + '</div>',
      type: 'info',

      inputValue: String(0),
      inputPlaceholder: 'You understand?',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      onOpen: function() {
        Swal.disableConfirmButton();
      }
    }).then((result) => {
      if (result.value) {
        callback();
      }
    });
    $('#confirm').change( function() {
      if (this.checked) {
        Swal.enableConfirmButton();
      } else {
        Swal.disableConfirmButton();
      }
    });
  }

  addManifests() {
    const tripIds = [];
    this.grid.api.forEachNodeAfterFilter((node) => {
      if (node.isSelected()) {
        tripIds.push(node.data.tripid);
      }
    });
    this.tripids = tripIds;
    this.selectedTripData = this.grid.api.getSelectedRows()[0];
    this.driverManifest.open();
  }

  onRealoadCheck() {
    this.tripids.forEach((row) => {
      const rowNode = this.grid.api.getRowNode(row);
      rowNode.setDataValue('tripmanifest', true);
    });
  }
  /**
   * @description verifica si tiene alert y las llama
   */
  private showAlert(event: CellClickedEvent): void {
    if (event.colDef.field === 'hasrideralert' && event.value) {
      const data: ITripDetail = assignNewObjet(event.data);
      this.getRiderAlerts(data.riderid, data.ridername);
    }
  }
  /**
   * @description verifica si tiene alert y las llama
   */
  private getRiderAlerts(riderId: number, name: string): void {
    this.loading.show();
    this.observables.push(this._riderAlertService.getAlertRiderByTypes(riderId, EnumTypeAlertRider.Billing).subscribe(
      (success: string[]) => {
        this.loading.hiden();
        viewMessageAlertRider(success, name);
      },
      error => {
        this.loading.hiden();
      }
    ));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/providers-billing/unprocessed-claims/unprocessed-claims.component.ts